export default "__VITE_ASSET__DE1A6xKm__"